import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { TriviaVideoChatBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function TriviaVideoChat() {
  return (
    <>
      <SEO
        title="Trivia Video Chat - Play Live with Strangers | Talkvee"
        description="Bored of standard random chat? Play live trivia video chat with strangers on Talkvee. Break the ice, answer questions, and see who wins in real-time."
        pathname="/trivia-video-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Trivia Video Chat", "item": "https://talkvee.com/trivia-video-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <TriviaVideoChatBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">Trivia Video Chat with Strangers</h1>
          <p className="landing-subtitle">
            Skip the awkward silence. Talkvee's built-in live trivia game lets you challenge strangers to general knowledge battles while video chatting. It is the ultimate icebreaker.
          </p>
          <Link to="/" className="tv-cta">🚀 Start a Trivia Match</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Why Play Trivia on Talkvee?</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#f1f5f9', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#0f172a', fontSize: '1.1rem'}}>🧠 Fast & Fun</h4>
              <p style={{margin: 0, color: '#334155', lineHeight: '1.6'}}>
                Questions load instantly. See who can answer the fastest right on your video screen.
              </p>
            </div>
            <div style={{background: '#f1f5f9', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#0f172a', fontSize: '1.1rem'}}>🏆 Earn Points</h4>
              <p style={{margin: 0, color: '#334155', lineHeight: '1.6'}}>
                Win trivia rounds against strangers to climb the Talkvee Global Leaderboard.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "How do I start a trivia video chat?",
              a: "Just hit 'Start Chatting'. Once connected with a partner, click the 'Trivia' icon to send them a game challenge!"
            },
            {
              q: "Are the trivia games free to play?",
              a: "Yes! All games on Talkvee, including Trivia, Tic-Tac-Toe, and the Laugh Challenge, are 100% free."
            },
            {
              q: "Do I have to play games?",
              a: "Not at all. If you just want to talk, you can ignore the game features and just enjoy the random video chat."
            }
          ]}
        />
      </div>
    </>
  );
}